<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">2023&nbsp; 期货台历介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">购买须知</li>
        </ul>
        <div class="details_gn" v-show="num == 0">
            <img src="/img/taili/taili03.png" alt="">
            <h5>金融日历全球假期</h5>
            <img  src="/img/taili/taili01.png" alt="">
            <h5>每月历史大事件</h5>
            <img  src="/img/taili/taili02.png" alt="">
            <h5>功能介绍，了解交易工具</h5>
            <img src="/img/taili/taili04.png" alt="">
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p> 
                1.付款后2个工作日内按你填写的地址邮寄台历，如需专票，则需要3个工作日邮寄台历。<br>
                2.本产品不包邮，付款时系统会根据您所在区域及购买数量自动计算累加费用。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 1
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn {
    min-height: 150px;
}
.details_gn h5{
    font-size: 15px;
    color: rgb(48, 49, 51);
    position: relative;
    padding-left: 5px;
}
.details_gn h5::before{
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    height: 15px;
    width: 3px;
    background: rgb(63, 135, 255);

}
</style>